import { Component, Input, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AlertController, ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { NgForm } from '@angular/forms';
import { GlobalService } from 'src/app/api/global.service';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { SelectPage as CompaniesSelectPage } from 'src/app/companies/select/select.page';
import { SelectComponent as TagsSelectPage } from 'src/app/components/tags/select/select.component';
import { ManagerComponent as GroupsManagerPage } from 'src/app/components/groups/manager/manager.component';
import { SelectPage as TeamMembersSelectPage } from 'src/app/team-members/select/select.page';
import { CompaniesContactsSelectPage as ContactsSelectPage } from 'src/app/modals/companies-contacts-select/companies-contacts-select.page';
import { CustomFieldsService, CustomFieldDef } from 'src/app/api/custom-fields.service';
import { ManageComponent as ManageCustomFieldsComponent } from 'src/app/components/custom-fields/manage/manage.component';


@Component({
  selector: 'app-create',
  templateUrl: './create.page.html',
  styleUrls: ['./create.page.scss'],
})
export class CreatePage implements OnInit {

  @Input() simple_create = false;
  countryCodes: any = null;
  languageOptions: any = null;

  @Input() inc_client: any;

  @Input() client = {
    active: false,
    display_name: '',
    first_name: '',
    last_name: '',
    middle_name: '',
    country_code: '+1',
    cell_country_code: '+1',
    alt_country_code: '+1',
    custom_id: '',
    phone_number: '',
    email: '',
    email_re: '',
    authentication_phone_number: '',
    is_a_client: false,
    str_address: '',
  city: '',
  province: '',
  country: '',
  postal_code: '',
  website:'',
  alt_phone: '',
  cell_phone: '',
  fax: '',
  custom_data: '',
  assigned_companies: [],
  family_members: [],
  team_members: [],
  groups: [],
  tags: [],
  gender: '',
  birthday: '',
  anniversary: '',
  sin: '',
  spoken_language_arr: [],
  spoken_language: '',
  company_guid: '',
  role_guid: '0',
  all_team_members: true,
  year_end_month: '12',
  year_end_day: '31',
  year_end_date: `${new Date().getFullYear()}-12-31`,
  is_default_for_company: false,
  is_default_for_role: false,
  }
  @Input() selecting_for_company = false;
  @Input() creating_for_company = false;
  @Input() company_guid = '';
  @Input() groups = [];
  @Input() is_a_client = null;
  clients_roles: any = [];



  items: MenuItem[];
  activeIndex = 0;
  detailsIndex = 'personalInfo';
  client_roles: any = [];
  team_member_roles = [];
  firmFieldDefs: CustomFieldDef[] = [];

  constructor(private modalController: ModalController, private apiService: ApiService, public globalService: GlobalService, private alertController: AlertController, private customFieldsService: CustomFieldsService) {

  }


  ngDoCheck() {
    this.CheckIfFormIsValid();
  }



  ngOnInit() {
    if(this.company_guid != '') this.client.company_guid = this.company_guid;
    if(this.groups.length > 0) this.client.groups = this.groups;
    else this.client.groups = [];
    if(this.is_a_client != null) this.client.is_a_client = this.is_a_client;
    if(this.selecting_for_company || this.creating_for_company) {
      this.GetClientsRoles();
    }
    this.GetExtraData();
    this.GetAllGroups();
    this.GetAllTags();
    this.MergeFirmCustomFields();
    this.items = [
      { label: 'Basic Information' },
      { label: 'Details' },
      { label: 'Review' }
    ];
    if (this.inc_client) {
      Object.keys(this.client).forEach(key => {
        if (this.inc_client[key] !== undefined) {
          console.log("ASDASDASDASD:    " + this.inc_client[key] +" ||| "+ key);
          this.client[key] = this.inc_client[key];
        }
      });
    }
  }
  async GetExtraData() {

    this.countryCodes = await this.apiService.getSpecificURL('https://app.fusionworkflow.com/assets/files/CountryCodes.json');
    this.languageOptions = await this.apiService.getSpecificURL('https://app.fusionworkflow.com/assets/files/Languages.json');
  }

  //Return the list of roles for clients
  async GetClientsRoles() {
    let data: any = await this.apiService.GetRoles();
    if (data.success) {
      this.clients_roles = data.data;
      this.client.role_guid = this.clients_roles[0].guid;
    }
  }


  formSubmitted = false;
  emailExists = false;
  emailNoMatch = false;
  emailInvalid = false;
  emailRequired = false;
  phoneInvalid = false;

  // async IsAClientChange() {
  //   console.log("Is A Client Change", this.client.is_a_client);
  //   console.log("Is a client", this.client);
  //   if(!this.client.is_a_client) {
  //     this.client.active = false;
  //   } 
  // }

    error_message = '';
  has_error = false;
  
  CheckIfFormIsValid() {
    this.error_message = '';
  let has_error = false;
  const messages: string[] = [];

  this.formSubmitted = true;
  this.emailExists = false;
  this.emailNoMatch = false;
  this.emailInvalid = false;
  this.emailRequired = false;
  this.phoneInvalid = false;

  // Email required for clients
  // if (this.client.email === '' && this.client.is_a_client) {
  //   this.emailRequired = true;
  //   messages.push('Email is required for clients.');
  //   has_error = true;
  // }
  
  // if (this.client.email === '' && this.client.active) {
  //   this.emailRequired = true;
  //   messages.push('Email is required for active portal contacts.');
  //   has_error = true;
  // }

  // Emails must match
  if (this.client.email !== this.client.email_re) {
    this.emailNoMatch = true;
    messages.push('Email addresses do not match.');
    has_error = true;
  }

  // Email format validation
  if (this.client.email !== '' && !this.globalService.validateEmail(this.client.email)) {
    this.emailInvalid = true;
    messages.push('Invalid email format.');
    has_error = true;
  }

  // Required fields
  if (this.client.display_name === '') {
    messages.push('Display name is required.');
    has_error = true;
  }

  if (this.client.first_name === '') {
    messages.push('First name is required.');
    has_error = true;
  }

  if (this.client.last_name === '') {
    messages.push('Last name is required.');
    has_error = true;
  }

  if(!this.client.all_team_members && this.client.team_members.length == 0) {
    messages.push('At least one team member must be assigned or select "Visible to all team members".');
    has_error = true;
  }

  if (this.creating_for_company && (!this.client.role_guid || this.client.role_guid === '0')) {
    messages.push('A role must be selected for this contact.');
    has_error = true;
  }

  // Write to string for tooltip or display
  this.error_message = messages.join('<br>');
  this.has_error = has_error;
}




  async Create() {
    

    if (this.has_error) return;


    await this.globalService.presentLoading('Creating...',10000);
    console.log("Creating Client", this.client);
    let client_create: any = await this.apiService.post(`clients`,this.client);

    if(!client_create.success) {
      this.globalService.dismissLoading();
      this.globalService.presentToastMessage(client_create.message,client_create.success);
      return;
    }

    let client_guid = client_create.data[0].guid;

    await this.apiService.put(`clients/${client_guid}`, this.client);
    if(this.client.groups) {
      await this.globalService.presentLoading('Assigning Groups',100000);
      for (const group of this.client.groups) {
      let data: any = await this.apiService.post(`groups/clients/${client_guid}`, group);
    }
    }
        
    this.globalService.dismissLoading();
    this.globalService.presentToastMessage(client_create.message,client_create.success);

    if (client_create.data && client_create.data[0]) {
      client_create.data[0].role_guid = this.client.role_guid;
      if (this.creating_for_company) {
        client_create.data[0].is_default_for_company = this.client.is_default_for_company;
        client_create.data[0].is_default_for_role = this.client.is_default_for_role;
      }
    }
    this.modalController.dismiss(client_create.data);


  }

  async GoToStep(step) {
    this.activeIndex = step;
  }

  async Close() {
    const isDirty = this.client.first_name?.trim() || this.client.last_name?.trim()
      || this.client.email?.trim() || this.client.display_name?.trim()
      || this.client.assigned_companies?.length > 0 || this.client.team_members?.length > 0;
    if (isDirty) {
      const alert = await this.alertController.create({
        header: 'Are you sure?',
        message: 'You have unsaved changes. If you cancel now, your work will be lost.',
        buttons: [
          { text: 'Keep Editing', role: 'cancel' },
          { text: 'Discard', role: 'destructive', handler: () => this.modalController.dismiss(null) }
        ]
      });
      await alert.present();
    } else {
      this.modalController.dismiss(null);
    }
  }

  async CopyPhoneNumber() {
    this.client.authentication_phone_number = this.client.phone_number;
  }

  async GoToStepDetails(step) {
    this.detailsIndex = step;
  }

  
    handleAddressChange(address: Address) {
      this.client.str_address = address.formatted_address;
      this.client.city = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['locality', 'political']))[0].long_name;
      this.client.province = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['administrative_area_level_1', 'political']))[0].long_name;
      this.client.country = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['country', 'political']))[0].long_name;
      this.client.postal_code = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['postal_code']))[0].long_name;
    }  

    openWebsite() {
      this.globalService.openWebsite(this.client.website);
    }
    formatPhoneNumber() {
     this.client.phone_number = this.globalService.FormatPhoneNumber(this.client.phone_number);
     this.client.alt_phone = this.globalService.FormatPhoneNumber(this.client.alt_phone);
     this.client.cell_phone = this.globalService.FormatPhoneNumber(this.client.cell_phone);
    }


  ToLower(val) {
    return val.toLowerCase();
  }

    async presentSelectCompaniesModal() {
      if(this.client_roles.length == 0) this.GetClientRoles();

      const modal = await this.modalController.create({
        component: CompaniesSelectPage,
        cssClass: 'small-modal tall-modal secondary-modal',
        backdropDismiss: false,
        componentProps: {
          selecting_for_contact: true,
          selected_companies: this.client.assigned_companies,
          remove_companies: this.client.assigned_companies,
          in_clients: [],
          target_header: 'Currently Selected'
        },
      })
      modal.onDidDismiss().then((data: any) => {
        if (data.data) {
          this.client.assigned_companies = data.data;
        }
      });
      return await modal.present()
    }

    async GetClientRoles() {
    let data: any = await this.apiService.GetRoles();
    if (data.success) {
      this.client_roles = data.data;
    }
  }
  GetClientRoleName(role_guid) {
    if(role_guid == '') return;
    if(this.client_roles.length == 0) return '';
    else return this.client_roles[this.globalService.GetArrayIndex(this.client_roles,role_guid)].title;
  }
  GetClientRoleColour(role_guid) {
     if(role_guid == '') return;
    if(this.client_roles.length == 0) return '';
    else return this.client_roles[this.globalService.GetArrayIndex(this.client_roles,role_guid)].colour;
  }
  async RemoveCompany(company) {
    this.globalService.RemoveFromArray(this.client.assigned_companies, company.guid);
  }


  async presentSelectFamilyMembers() {
      const modal = await this.modalController.create({
        component: ContactsSelectPage,
        cssClass: 'small-modal tall-modal secondary-modal',
        backdropDismiss: false,
        componentProps: {
          selecting_for_family: true,
          selected_clients: this.client.family_members,
          remove_clients: this.client.family_members,
          in_clients: [],
          target_header: 'Currently Selected',
          modal_title: 'Select Family Members',
          hide_companies: true
        },
      })
      modal.onDidDismiss().then((data: any) => {
        if (data.data) {
          this.client.family_members = data.data.clients;
        }
      });
      return await modal.present()
    }

    async RemoveFamilyMember(family_member) {
    this.globalService.RemoveFromArray(this.client.family_members, family_member.guid);
  }


    customFields: { name: string; type: string; value: any; _is_new?: boolean }[] = [];

addField() {
  this.customFields.push({
    name: '',
    type: 'text',
    value: '',
    _is_new: true
  });
}

removeField(index: number) {
  this.customFields.splice(index, 1);
}

// Firm-wide custom field definitions (Manage Firm > Contacts) that aren't already present here get
// added with a blank value - see CustomFieldsService.MergeFieldDefsInto.
async MergeFirmCustomFields() {
  const defs = await this.customFieldsService.GetFieldDefs();
  this.firmFieldDefs = defs.contacts;
  this.customFieldsService.MergeFieldDefsInto(this.customFields, defs.contacts, defs.loaded, defs.deleted_contacts);
}

IsGlobalField(field: any): boolean {
  return this.firmFieldDefs?.some(d => d.name === field.name) ?? false;
}

async OpenManageGlobalCustomFields() {
  const modal = await this.modalController.create({
    component: ManageCustomFieldsComponent,
    cssClass: 'tall-modal medium-modal secondary-modal',
    backdropDismiss: false,
    componentProps: { entity_type: 'contacts' },
  });
  modal.onDidDismiss().then(async (data: any) => {
    if (data?.data?.saved) await this.MergeFirmCustomFields();
  });
  return await modal.present();
}


  // Typeahead for Groups/Tags (same pattern as the company and project create pages) - the search-icon
  // buttons open the modals for bulk selection or creating a brand new one, and reload these lists
  // when they close so anything created there is searchable straight away.
  all_groups: any[] = [];
  group_search_query = '';
  group_suggestions: any[] = [];
  group_suggestions_active_index = -1;
  show_group_suggestions = false;

  all_tags: any[] = [];
  tag_search_query = '';
  tag_suggestions: any[] = [];
  tag_suggestions_active_index = -1;
  show_tag_suggestions = false;

  async GetAllGroups() {
    const data: any = await this.apiService.GetGroups('clients');
    this.all_groups = data?.data || [];
  }

  async GetAllTags() {
    const data: any = await this.apiService.GetTags('clients');
    this.all_tags = data?.data || [];
  }

  OnGroupSearchChange() {
    const q = (this.group_search_query || '').trim().toLowerCase();
    this.group_suggestions_active_index = -1;
    if (!q || !this.all_groups?.length) {
      this.group_suggestions = [];
      this.show_group_suggestions = false;
      return;
    }
    const selectedGuids = new Set((this.client.groups || []).map((g: any) => g.guid));
    this.group_suggestions = this.all_groups
      .filter((g: any) => !selectedGuids.has(g.guid) && (g.title || '').toLowerCase().includes(q))
      .slice(0, 15);
    this.show_group_suggestions = this.group_suggestions.length > 0;
  }

  OnGroupInputFocus() {
    if (this.group_search_query) this.OnGroupSearchChange();
  }

  OnGroupInputBlur() {
    this.show_group_suggestions = false;
  }

  OnGroupInputKeydown(event: KeyboardEvent) {
    if (!this.show_group_suggestions || this.group_suggestions.length === 0) return;
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.group_suggestions_active_index = Math.min(this.group_suggestions_active_index + 1, this.group_suggestions.length - 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.group_suggestions_active_index = Math.max(this.group_suggestions_active_index - 1, 0);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      const index = this.group_suggestions_active_index >= 0 ? this.group_suggestions_active_index : 0;
      this.SelectGroupSuggestion(this.group_suggestions[index]);
    } else if (event.key === 'Escape') {
      this.show_group_suggestions = false;
    }
  }

  SelectGroupSuggestion(group: any) {
    if (!group?.guid) return;
    if (!(this.client.groups || []).some((g: any) => g.guid === group.guid)) {
      this.client.groups = [...(this.client.groups || []), group] as any;
    }
    this.ClearGroupSearchState();
  }

  private ClearGroupSearchState() {
    this.group_search_query = '';
    this.group_suggestions = [];
    this.group_suggestions_active_index = -1;
    this.show_group_suggestions = false;
  }

  OnTagSearchChange() {
    const q = (this.tag_search_query || '').trim().toLowerCase();
    this.tag_suggestions_active_index = -1;
    if (!q || !this.all_tags?.length) {
      this.tag_suggestions = [];
      this.show_tag_suggestions = false;
      return;
    }
    const selectedGuids = new Set((this.client.tags || []).map((t: any) => t.guid));
    this.tag_suggestions = this.all_tags
      .filter((t: any) => !selectedGuids.has(t.guid) && (t.title || '').toLowerCase().includes(q))
      .slice(0, 15);
    this.show_tag_suggestions = this.tag_suggestions.length > 0;
  }

  OnTagInputFocus() {
    if (this.tag_search_query) this.OnTagSearchChange();
  }

  OnTagInputBlur() {
    this.show_tag_suggestions = false;
  }

  OnTagInputKeydown(event: KeyboardEvent) {
    if (!this.show_tag_suggestions || this.tag_suggestions.length === 0) return;
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.tag_suggestions_active_index = Math.min(this.tag_suggestions_active_index + 1, this.tag_suggestions.length - 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.tag_suggestions_active_index = Math.max(this.tag_suggestions_active_index - 1, 0);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      const index = this.tag_suggestions_active_index >= 0 ? this.tag_suggestions_active_index : 0;
      this.SelectTagSuggestion(this.tag_suggestions[index]);
    } else if (event.key === 'Escape') {
      this.show_tag_suggestions = false;
    }
  }

  SelectTagSuggestion(tag: any) {
    if (!tag?.guid) return;
    if (!(this.client.tags || []).some((t: any) => t.guid === tag.guid)) {
      this.client.tags = [...(this.client.tags || []), tag] as any;
    }
    this.ClearTagSearchState();
  }

  private ClearTagSearchState() {
    this.tag_search_query = '';
    this.tag_suggestions = [];
    this.tag_suggestions_active_index = -1;
    this.show_tag_suggestions = false;
  }

  // Groups and tags picked through the search boxes can be taken back off again
  RemoveGroup(group: any) {
    this.globalService.RemoveFromArray(this.client.groups, group.guid);
  }

  RemoveTag(tag: any) {
    this.globalService.RemoveFromArray(this.client.tags, tag.guid);
  }

//TAGS
  //Present the modal to select tags to apply to the company
  async presentSelectTagsModal() {
    const modal = await this.modalController.create({
      component: TagsSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        url: 'clients',
        client: this.client,
        selected_tags: this.client.tags
      }
    })
    modal.onDidDismiss().then((data: any) => {
      // A tag may have been created in the modal - reload the list the tag search box works from
      this.GetAllTags();
      if (data.data) {
          this.client.tags = data.data;
        }
    });
    return await modal.present()
  }


  // GROUPS
  async presentSelectGroupsModal() {
    const modal = await this.modalController.create({
      component: GroupsManagerPage,
      cssClass: 'medium-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        url: 'clients',
        selection_mode: true,
        max_selection: 999,
        selected_groups: [...this.client.groups],
        modal_title: 'Select Groups'
      }
    });
    modal.onDidDismiss().then((data: any) => {
      // A group may have been created in the modal - reload the list the group search box works from
      this.GetAllGroups();
      if (data && data.data) {
        this.client.groups = data.data;
      }
    });
    return await modal.present();
  }



  //select team members and add them to the companies team members
  async presentSelectTeamMembersModal() {
    if(this.team_member_roles.length == 0) this.GetTeamRoles();
    const modal = await this.modalController.create({
      component: TeamMembersSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        selecting_for_company: true,
        selected_team_members: this.client.team_members,
        remove_team_members: this.client.team_members,
        in_team_members: [],
        target_header: 'Currently Selected'
      }
    })
    modal.onDidDismiss().then((data: any) => {
       if (data.data) {
          this.client.team_members = data.data;
        }

    });
    return await modal.present()
  }

  //Return the list of team member roles
  async GetTeamRoles() {
    let data: any = await this.apiService.get('firms/team_members/roles');
    if (data.success) {
      this.team_member_roles = data.data;
    }
  }

  GetEmployeeTypeText(guid) {
    let i = this.globalService.GetArrayIndex(this.team_member_roles, guid);
    if (i == -1)
      return "No Role";
    else
      return this.team_member_roles[i].title;
  }

  GetEmployeeTypeColour(guid) {
    let i = this.globalService.GetArrayIndex(this.team_member_roles, guid);
    if (i == -1)
      return "#ADD8E6";
    else
      return this.team_member_roles[i].colour;
  }

  //This will create the clients, then create all the links required for the client and update the details.
  async FullCreate() {
    // Ask about any field added via addField() this session, before the loading overlay starts, so
    // its alert doesn't stack on top of it - mirrors UpdateBasicInfo() in clients/details.
    this.firmFieldDefs = await this.customFieldsService.PromptAndSaveNewFieldScopes('contacts', this.customFields);
    await this.globalService.presentLoading('Creating Client',100000);
    let client_create: any = await this.apiService.post(`clients`,this.client);
    if(!client_create.success) {
      this.globalService.dismissLoading();
      this.globalService.presentToastMessage(client_create.message,client_create.success);
      return;
    }
    await this.globalService.presentLoading('Assigning Tags',100000);
    let client_guid = client_create.data[0].guid;
    for (const tag of this.client.tags) {
        let tag_create: any = await this.apiService.post(`clients/tags/${client_guid}`, tag);
    }
    await this.globalService.presentLoading('Assigning Team Memebers',100000);
    for (const team_member of this.client.team_members) {
        let data: any = await this.apiService.post(`clients/team_members/${client_guid}`, team_member);
    }
    await this.globalService.presentLoading('Assigning Family Memebers',100000);
    for (const family_member of this.client.family_members) {
        let data: any = await this.apiService.post(`clients/family_members/${client_guid}`, family_member);
    }
     await this.globalService.presentLoading('Assigning Groups',100000);
    for (const group of this.client.groups) {
      let data: any = await this.apiService.post(`groups/clients/${client_guid}`, group);
    }
    await this.globalService.presentLoading('Assigning To Companies',100000);
    for (const company of this.client.assigned_companies) {
      let post_data = {
        guid: client_guid,
        role_guid: company.role_guid

      }
        let data: any = await this.apiService.post(`companies/clients/${company.guid}`, post_data);
    }
    await this.globalService.presentLoading('Finishing Creation',100000);
    this.customFieldsService.AssignFieldIds(this.customFields);
    this.client.custom_data = JSON.stringify(this.customFields);
    this.client.spoken_language = this.client.spoken_language_arr.map(lang => typeof lang === 'string' ? lang : lang.name || lang.value || '').join('~');
    let client_details: any = await this.apiService.put(`clients/${client_guid}`,this.client);
    this.globalService.dismissLoading();

    this.modalController.dismiss(client_create.data[0]);


  }




}
